/**
 *
 * @Pattern https://mgechev.github.io/angularjs-in-patterns/#facade
 */

export default function BookingPeriods(
    BookingPeriodsService,
    BookingPeriodsEntriesFactory
) {
    var fn = this;

    /**
     * API v3
     */

    // fn.getExpanded = function (period, iteratorIndex) {
    //     return BookingPeriodsService.getExpanded(period, iteratorIndex);
    // };

    fn.get = function (id) {
        return BookingPeriodsService.get(id);
    };

    fn.getEntries = function (id) {
        return BookingPeriodsService.getEntries(id);
    };

    fn.addEntry = function (id, entry) {
        return BookingPeriodsService.addEntry(id, entry);
    };

    fn.updateEntry = function (id, bpeId, bpe) {
        return BookingPeriodsService.updateEntry(id, bpeId, bpe);
    };

    fn.checkAvailability = function (
        start,
        end,
        resource_id,
        bookingId,
        testKitPeriod
    ) {
        return BookingPeriodsService.checkAvailability(
            start,
            end,
            resource_id,
            bookingId,
            testKitPeriod
        );
    };

    fn.calculatePrice = function (
        start,
        end,
        resourceId,
        activity_id,
        user_id
    ) {
        return BookingPeriodsService.calculatePrice(
            start,
            end,
            resourceId,
            activity_id,
            user_id
        );
    };

    /**
     * Factory methods
     */

    // Booking period entries (factory)
    fn.updatePrices = function (bookingPeriods) {
        return BookingPeriodsEntriesFactory.updatePrices(bookingPeriods);
    };

    fn.findUniqueEntries = function (bookingPeriods) {
        return BookingPeriodsEntriesFactory.findUniqueEntries(bookingPeriods);
    };

    return fn;
}
